// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';

export type ArticleMetaType = {|
  author: string,
  date: string,
  categories: Array<string | {| name: string, href: string |}>,
  className?: string,
|};

export default (props: ArticleMetaType) => {
  const date = new Date(props.date);
  const categories = props.categories.reduce((acc, category, index) => {
    if (typeof category === 'string') {
      acc.push(category);
    } else {
      acc.push(
        <a className={styles.categoryLink} href={category.href}>
          {category.name}
        </a>,
      );
    }
    if (index !== props.categories.length - 1) acc.push(', ');
    return acc;
  }, []);

  return (
    <p className={cx(styles.meta, props.className)}>
      <span>By {props.author}</span>
      <span>{date.toDateString()}</span>
      {props.categories.length > 0 && <span>{categories}</span>}
    </p>
  );
};
